/**
 * Return if current time is in christmas time.
 * Christmas time: 24.12 - 27.12
 */
export const isChristmasTime = (): boolean => {
  const now = new Date()
  const month = now.getMonth() + 1
  const day = now.getDate()

  return month === 12 && day >= 24 && month === 12 && day <= 27
}
